import {uniqBy} from "lodash"
import {UserList} from "@irati/types"
import {ApolloState} from "../apolloStateInterface"

type QueryVariables = {
  query: any
  variables: {[key: string]: any}
}

export default function pagination({query, variables}: QueryVariables, apollo: ApolloState, key = Object.keys(apollo.data)[0]) {
  const {data} = apollo

  // @TODO I think we should be user total here instead of count
  if (data[key]?.count === data[key]?.results.length) {
    return Promise.resolve(data)
  }

  return apollo.fetchMore({
    query,
    variables: {...variables, offset: data[key].results.length, cursor: data[key].cursor},
    updateQuery: (previousResult, {fetchMoreResult}) => {
      const nextCursor = fetchMoreResult[key].cursor
      const oldFeed = previousResult[key].results
      const newFeed = uniqBy([...oldFeed, ...fetchMoreResult[key].results], "uuid")
      const newOffset = newFeed.length

      return {
        [key]: {
          ...fetchMoreResult[key],
          offset: newOffset,
          results: newFeed,
          cursor: nextCursor
        }
      }
    }
  })
}

export interface List<T = any> {
  results: T[]
  count?: UserList["count"]
  cursor?: UserList["cursor"]
  limit?: UserList["limit"]
  offset?: UserList["offset"]
  total?: UserList["total"]
  hasMore?: UserList["hasMore"]
}

export function emptyList(): List {
  return {
    results: [],
    count: 0,
    cursor: "",
    limit: 0,
    offset: 0,
    total: 0,
    hasMore: false
  }
}
